import type { Route } from '../types';

/**
 * В БД при выборе погрузки «Заявка» хранится loadingPointType=shipper и loadingPointId=shipperId.
 * Для списка грузов и UI нужен именно ID заявки: он лежит в стопе погрузки (pointType=application, pointId)
 * или в связи route.applications.
 */
export function deriveLoadingApplicationIdForUi(route: Route | null | undefined): number | undefined {
  if (!route || route.loadingPointType !== 'shipper') {
    return undefined;
  }
  const stops = [...(((route as unknown as { stops?: Array<{ type?: string; position?: number; pointType?: string | null; pointId?: number | null }> }).stops) || [])].sort(
    (a, b) => (a.position ?? 0) - (b.position ?? 0)
  );
  const mainLoading =
    stops.find((s) => s.type === 'loading' && s.position === 0) || stops.find((s) => s.type === 'loading');
  if (mainLoading && mainLoading.pointType === 'application' && mainLoading.pointId != null) {
    const n = Number(mainLoading.pointId);
    return Number.isFinite(n) && n > 0 ? n : undefined;
  }
  const fromLink = route.applications?.[0]?.applicationId;
  if (fromLink != null) {
    const n = Number(fromLink);
    return Number.isFinite(n) && n > 0 ? n : undefined;
  }
  return undefined;
}
